import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { Alert, Button, Col, Row, Table, Form, ToggleButton } from "react-bootstrap";
import { clients, emailPayload, getConsensoDate, getTime, root, validateEmail } from "../utils/Constants";
import { ILoader } from "../App";
import { getTokens } from "../services/Auth";
import { getUsersByWebinar, registerUserInWebinar, deleteUser, getWebinarByID, saveUser, getWebinarRegistrants } from "../services/Webinar";
import { sendMail } from "../services/Privacy";
import { SendFill, Link45deg, CheckLg, ArrowLeft, CalendarEvent, Broadcast, Clipboard, ClipboardCheck, PersonPlusFill, Inbox, Search } from "react-bootstrap-icons";
import { IWebinarDB } from "../components/MainForm/MainForm";

interface Props {
    handleLoader: ILoader;
}

export interface IUser {
    id: string;
    email: string;
    name: string;
    surname: string;
    id_webinar: string;
    consenso: number;
    responses?: string;
}

export default function InfoWebinar({ handleLoader }: Props) {
    const navigate = useNavigate();
    const location = useLocation();
    const localChannel = localStorage.getItem("channel");
    const formURL: string = "http://brainbites.maggiolicloud.it";
    const { id } = useParams();

    const [users, setUsers] = useState<IUser[]>([]);
    const [registrants, setRegistrants] = useState<any[]>([]);
    const [copyMessage, setCopyMessage] = useState<string>("Copia link form consensi");
    const [error, setError] = useState<string>("");
    const [success, setSuccess] = useState<string>("");
    const [name, setName] = useState<string>("");
    const [surname, setSurname] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [radioValue, setRadioValue] = useState("1");
    const [webinar, setWebinar] = useState<IWebinarDB | null>(null);
    const [copiedLink, setCopiedLink] = useState<number>(-1);
    const [searchEmail, setSearchEmail] = useState<string>("");

    const radios = [
        { name: "Non registrati", value: "1", variant: "outline-secondary" },
        // { name: "Con consenso", value: "2", variant: "outline-success" },
        { name: "Registrati", value: "4", variant: "outline-primary" },
    ];

    useEffect(() => {
        loadWebinar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (radioValue === "4") {
            loadRegistrants();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [radioValue]);

    const authenticate = (channel: string) => {
        const payload = localStorage.getItem("tokens");
        if (localChannel !== channel.toString() || payload === null) {
            goToAuthPage(channel);
            return;
        }
        const refreshToken = JSON.parse(payload).refresh_token;
        const accessToken = JSON.parse(payload).access_token;
        const tokenExpireDate = JSON.parse(payload).access_token_expire_date;
        if (accessToken !== null && tokenExpireDate !== null && parseInt(tokenExpireDate) > Date.now()) {
            return;
        }
        if (refreshToken !== null) {
            getTokens("refresh_token", refreshToken, channel);
            return;
        }
    };

    const goToAuthPage = (channel: string) => {
        sessionStorage.setItem("temp_channel", channel);
        sessionStorage.setItem("last_path", location.pathname);
        navigate(root + "authcode");
    };

    const loadWebinar = async () => {
        handleLoader.setLoading(true);
        const res = await getWebinarByID(id);
        if (!res.status) {
            handleLoader.setLoading(false);
            return;
        }
        setWebinar(res.data);
        authenticate(res.data.channel);
        loadUsers();
    };

    const loadRegistrants = async () => {
        handleLoader.setLoading(true);
        const channel = webinar.channel;

        const res = await getWebinarRegistrants(clients[channel].orgKey, webinar.webinar_id);
        handleLoader.setLoading(false);
        if (!res.ok) {
            return;
        }

        const data = await res.json();
        setRegistrants(data);
    };

    const loadUsers = async () => {
        handleLoader.setLoading(true);
        const resUsers = await getUsersByWebinar(id);
        handleLoader.setLoading(false);
        if (resUsers.status) {
            setUsers(resUsers.data);
        }
    };

    const onClickSendEmail = async (user: IUser) => {
        handleLoader.setLoading(true);
        const res = await sendMail(emailPayload(user.email, id, webinar.title, webinar.start_date));
        handleLoader.setLoading(false);
        if (res.status) {
            setSuccess("Email inviata con successo!");
            window.setTimeout(() => setSuccess(""), 3000);
        }
    };

    const onClickCopy = () => {
        navigator.clipboard.writeText(`${formURL}/register/${id}`);
        setCopyMessage("Link copiato!");
        window.setTimeout(() => setCopyMessage("Copia link form consensi"), 2000);
    };

    const onClickCopyJoinUrl = (joinUrl: string, index: number) => {
        navigator.clipboard.writeText(joinUrl);
        setCopiedLink(index);
        window.setTimeout(() => setCopiedLink(-1), 2000);
    };

    const onClickRegisterUser = async (user: IUser, isList: boolean = false, tryToDelete: boolean = true, showMessages: boolean = true) => {
        const payload = {
            firstName: user.name,
            lastName: user.surname,
            email: user.email,
        };
        if (user.responses) {
            payload["responses"] = JSON.parse(user.responses);
        }
        !isList && handleLoader.setLoading(true);
        const res = await registerUserInWebinar(clients[webinar.channel].orgKey, webinar.webinar_id, payload);
        if (!res.ok) {
            const data = await res.json();
            showMessages && setError(data.description);
            handleLoader.setLoading(false);
            window.setTimeout(() => setError(""), 3000);
            return false;
        }

        if (!tryToDelete) {
            handleLoader.setLoading(false);
            showMessages && setSuccess("Utente registrato con successo!");
            window.setTimeout(() => setSuccess(""), 3000);
            return true;
        }

        const resDelete = await deleteUser(user.id);
        handleLoader.setLoading(false);
        if (resDelete.status) {
            !isList && setUsers(users.filter((u) => u.id !== user.id));
            showMessages && !isList && setSuccess("Utente registrato all'evento con successo!");
            window.setTimeout(() => setSuccess(""), 3000);
        }
        return resDelete.status;
    };

    const onClickRegisterAll = async () => {
        handleLoader.setLoading(true);
        const consent: string = radioValue === "1" ? "0" : "1";
        const res = await getUsersByWebinar(id, consent);
        if (!res.status) {
            handleLoader.setLoading(false);
            return;
        }

        const usersTemp: IUser[] = res.data;
        let check: boolean = true;
        for (let i = 0; i < usersTemp.length; i++) {
            check = (await onClickRegisterUser(usersTemp[i], true, true)) && check;
        }
        if (check) {
            setSuccess("Utenti registrati con successo!");
            window.setTimeout(() => setSuccess(""), 3000);
        } else {
            setError("Non tutti gli utenti sono stati registrati. È possibile che alcuni di questi siano già iscritti all'evento.");
            window.setTimeout(() => setError(""), 3000);
        }
        await loadUsers();
    };

    const onClickManuallyRegister = () => {
        const tempUser: IUser = { name: name, surname: surname, email: email, id_webinar: id, id: "0", consenso: 0 };
        onClickRegisterUser(tempUser, false, false);
    };

    const onClickManuallySend = async () => {
        const payload = {
            name: name,
            surname: surname,
            email: email,
            webinar_id: id,
        };
        handleLoader.setLoading(true);
        const resUser = await saveUser(payload);
        if (!resUser.ok) {
            const dataUser = await resUser.json();
            setError(dataUser.message);
            window.setTimeout(() => setError(""), 3000);
            handleLoader.setLoading(false);
            return;
        }

        const res = await sendMail(emailPayload(email, id, webinar.title, webinar.start_date));
        handleLoader.setLoading(false);
        if (res.status) {
            setSuccess("Email inviata con successo!");
            await loadUsers();
            window.setTimeout(() => setSuccess(""), 3000);
        }
    };

    if (handleLoader.loading) {
        return <div></div>;
    }

    if (webinar === null) {
        return (
            <div className="admin-card admin-empty">
                <Inbox />
                <p>Webinar non trovato</p>
                <Link to={root + "list"} className="admin-back mt-3">
                    <ArrowLeft /> Torna alla lista
                </Link>
            </div>
        );
    }

    const getTable = (headers: string[], type: string) => {
        return (
            <div className="table-responsive">
                <Table hover className="admin-table">
                    <thead>
                        <tr>
                            {headers.map((r, i) => (
                                <th key={i}>{r}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {type !== "users"
                            ? filterRegistrants.map((elem, i) => (
                                  <tr key={i}>
                                      <td>{elem.firstName.length > 15 ? `${elem.firstName.slice(0, 15)}...` : elem.firstName}</td>
                                      <td>{elem.lastName.length > 15 ? `${elem.lastName.slice(0, 15)}...` : elem.lastName}</td>
                                      <td>{elem.email}</td>
                                      <td>
                                          {i === copiedLink ? (
                                              <Button variant="success" size="sm" className="icon-btn">
                                                  <CheckLg />
                                              </Button>
                                          ) : (
                                              <Button
                                                  variant="light"
                                                  size="sm"
                                                  className="icon-btn"
                                                  title="Copia link di accesso"
                                                  onClick={() => onClickCopyJoinUrl(elem.joinUrl, i)}
                                              >
                                                  <Link45deg />
                                              </Button>
                                          )}
                                      </td>
                                      <td>
                                          {elem.status === "APPROVED" ? (
                                              <span className="admin-badge success">Approvato</span>
                                          ) : (
                                              <span className="admin-badge danger">{elem.status}</span>
                                          )}
                                      </td>
                                      <td className="cell-muted text-nowrap">
                                          {getConsensoDate(elem.registrationDate, true)}
                                          <br />
                                          {getTime(elem.registrationDate, true)}
                                      </td>
                                  </tr>
                              ))
                            : users
                                  //   .filter((e) => (radioValue === "1" && e.consenso === 0) || (radioValue === "2" && e.consenso === 1))
                                  .map((elem, i) => (
                                      <tr key={i}>
                                          <td>{elem.name}</td>
                                          <td>{elem.surname}</td>
                                          <td>{elem.email}</td>
                                          <td className="text-end">
                                              <Button size="sm" variant="outline-primary" onClick={() => onClickRegisterUser(elem)}>
                                                  <SendFill /> Registra
                                              </Button>
                                          </td>
                                      </tr>
                                  ))}
                    </tbody>
                </Table>
            </div>
        );
    };

    const checkRegisterSingle: boolean = name === "" || surname === "" || email === "" || !validateEmail(email);
    const filterRegistrants =
        searchEmail.length >= 3 ? registrants.filter((r) => r.email.toLowerCase().includes(searchEmail.toLowerCase())) : registrants;
    const registransHeaders: string[] = ["Nome", "Cognome", "Email", "Link", "Stato", "Data"];
    const usersHeaders: string[] = ["Nome", "Cognome", "Email", ""];

    return (
        <>
            <Link to={root + "list"} className="admin-back">
                <ArrowLeft /> Lista webinar
            </Link>

            <div className="admin-page-header">
                <div>
                    <h1>{webinar.title}</h1>
                    {webinar.subtitle && <p className="subtitle">{webinar.subtitle}</p>}
                    <div className="admin-meta">
                        <span>
                            <CalendarEvent /> {new Date(webinar.start_date).toLocaleDateString("it-IT", { timeZone: "UTC" })}
                        </span>
                        <span>
                            <Broadcast /> Canale {webinar.channel}
                        </span>
                    </div>
                </div>
                {window.isSecureContext ? (
                    <Button variant="outline-primary" onClick={() => onClickCopy()}>
                        {copyMessage === "Link copiato!" ? <ClipboardCheck /> : <Clipboard />} {copyMessage}
                    </Button>
                ) : (
                    <span className="cell-mono">{`${formURL}?webinar=${id}`}</span>
                )}
            </div>

            {error !== "" && (
                <Alert variant="danger" className="mb-4">
                    <strong>Attenzione:</strong> {error}
                </Alert>
            )}
            {success !== "" && (
                <Alert variant="success" className="mb-4">
                    {success}
                </Alert>
            )}

            <div className="admin-card">
                <div className="admin-card-header">
                    <h2>Registra utente singolo</h2>
                </div>
                <div className="admin-card-body">
                    <Row className="g-2">
                        <Col md={3}>
                            <Form.Control type="text" placeholder="Nome" onChange={(e) => setName(e.target.value)} />
                        </Col>
                        <Col md={3}>
                            <Form.Control type="text" placeholder="Cognome" onChange={(e) => setSurname(e.target.value)} />
                        </Col>
                        <Col md={4}>
                            <Form.Control type="email" placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
                        </Col>
                        <Col md={2} className="d-grid">
                            <Button variant="primary" onClick={() => onClickManuallyRegister()} disabled={checkRegisterSingle}>
                                <PersonPlusFill /> Registra
                            </Button>
                        </Col>
                    </Row>
                </div>
            </div>

            <div className="admin-card">
                <div className="admin-card-header">
                    <div className="admin-segmented">
                        {radios.map((radio, idx) => (
                            <ToggleButton
                                key={idx}
                                id={`radio-${idx}`}
                                type="radio"
                                variant="light"
                                name="radio"
                                value={radio.value}
                                checked={radioValue === radio.value}
                                onChange={(e) => setRadioValue(e.currentTarget.value)}
                            >
                                {radio.name}
                            </ToggleButton>
                        ))}
                    </div>

                    {radioValue === "1" && users.length > 0 && (
                        <Button variant="primary" size="sm" onClick={() => onClickRegisterAll()}>
                            <SendFill /> Registra tutti
                        </Button>
                    )}

                    {radioValue === "4" && (
                        <div className="position-relative" style={{ minWidth: 260 }}>
                            <Search className="position-absolute text-muted" style={{ left: 12, top: "50%", transform: "translateY(-50%)" }} />
                            <Form.Control
                                type="text"
                                size="sm"
                                value={searchEmail}
                                onChange={(e) => setSearchEmail(e.target.value)}
                                placeholder="Cerca per email..."
                                style={{ paddingLeft: 34 }}
                            />
                        </div>
                    )}
                </div>

                {radioValue === "4" &&
                    (filterRegistrants.length > 0 ? (
                        getTable(registransHeaders, "registrants")
                    ) : (
                        !handleLoader.loading && (
                            <div className="admin-empty">
                                <Inbox />
                                <p>Nessun utente trovato</p>
                            </div>
                        )
                    ))}

                {radioValue !== "4" &&
                    (users.length === 0 ? (
                        <div className="admin-empty">
                            <Inbox />
                            <p>Nessun utente in coda per questo webinar</p>
                        </div>
                    ) : (
                        getTable(usersHeaders, "users")
                    ))}
            </div>
        </>
    );
}
